<template>
	<div>
		<q-table
			ref="table"
			:data="users_subscribed"
			:columns="columns"
			:pagination.sync="server_pagination"
			selection="multiple"
			:selected.sync="users_subscribed_selected"
			@request="request"
			:loading="loading"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			class="q-mt-md"
			binary-state-sort
		>
			<template slot="top" slot-scope="props">
				<div class="col" />
				<q-btn
					color="tertiary"
					class="q-mr-sm"
					icon="fas fa-file-download"
					:label="$t('download_guest_list')"
					@click="downloadGuestList"
					:disable="users_subscribed.length < 1 || !manageLiveClasses"
				/>
				<q-btn
					color="negative"
					icon="fas fa-ban"
					:label="$t('remove')"
					@click="removeUsers"
					class="q-mr-sm"
					v-if="users_subscribed_selected.length > 0"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th auto-width>
					<q-checkbox
						v-model="props.selected"
						indeterminate-value="some"
						:disable="!manageLiveClasses"
					/>
				</q-th>

				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props">
				<q-td auto-width>
					<q-checkbox
						color="primary"
						v-model="props.selected"
						:disable="!manageLiveClasses"
					/>
				</q-td>

				<q-td key="id" :props="props">
					{{ props.row.id }}
				</q-td>

				<q-td key="name" :props="props">
					{{ props.row.name }}
				</q-td>

				<q-td key="email" :props="props">
					{{ props.row.email }}
				</q-td>

				<q-td key="document" :props="props">
					{{ props.row.document }}
				</q-td>

				<q-td key="branches" :props="props">
					<q-btn
						v-if="props.row.branches.length > 1"
						color="primary"
						text-color="white"
						:label="getQuantityBranches(props.row.branches)"
						no-ripple
					>
						<q-tooltip>
							<p v-if="props.row.branches.length > 1" class="tooltip q-mb-sm">
								{{ $t('branches') }}:
								<span v-for="(branch, index) in props.row.branches" :key="index">
									{{ branch }}
									<span v-if="props.row.branches.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
					<span v-if="props.row.branches.length < 2">{{
						String(props.row.branches)
					}}</span>
				</q-td>

				<q-td key="areas" :props="props">
					<q-btn
						v-if="props.row.areas.length > 1"
						color="primary"
						text-color="white"
						:label="props.row.areas ? props.row.areas.length : 0"
						no-ripple
					>
						<q-tooltip>
							<p v-if="props.row.areas.length > 1" class="tooltip q-mb-sm">
								{{ $t('areas') }}:
								<span v-for="(area, index) in props.row.areas" :key="index">
									{{ area }}
									<span v-if="props.row.areas.length - 1 > index">, </span>
								</span>
							</p>
						</q-tooltip>
					</q-btn>
					<span v-if="props.row.areas.length < 2">{{ String(props.row.areas) }}</span>
				</q-td>

				<q-td key="profile" :props="props">
					{{ translateProfiles(props.row.profile) }}
				</q-td>

				<q-td key="is_present" :props="props">
					<q-checkbox aria-readonly="true" disable v-model="props.row.is_present" />
				</q-td>

				<q-td key="subscribe_date" :props="props">
					{{ fDate(props.row.subscribe_date) }}
				</q-td>

				<q-td auto-width key="actions" :props="props">
					<q-btn
						round
						flat
						icon="fas fa-trash"
						color="negative"
						@click="removeUser(props)"
						:disable="!manageLiveClasses"
					>
						<q-tooltip>
							{{ $t('delete_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>
		</q-table>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_live_classes' })"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {
	name: 'SubscribersTab',

	props: ['manageLiveClasses'],

	data() {
		return {
			branches: [],
			live_class_id: '',
			users_subscribed: [],
			users_subscribed_selected: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: false,
				},
				{
					name: 'name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: false,
				},
				{
					name: 'branches',
					required: true,
					label: 'branches',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'areas',
					required: true,
					label: 'areas',
					align: 'left',
					field: 'areas',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
				{
					name: 'is_present',
					required: true,
					label: 'present',
					align: 'left',
					field: 'is_present',
					sortable: false,
				},
				{
					name: 'subscribe_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'subscribe_date',
					sortable: false,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'right',
					field: 'actions',
					sortable: false,
				},
			],
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
			profiles: 'registration_lists/profiles',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '90vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter_guests,
				ordering: order_by,
			}

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${
						this.live_class_id
					}/guests/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count

					this.users_subscribed = response.data.results.map((result) => {
						let user = {
							id: result.user.id,
							name: result.user.name,
							email: result.user.email,
							profile: result.user.profile,
							document: result.user.document ? result.user.document : '',
							branches: result.user.branches ? result.user.branches : [],
							areas: result.user.areas ? result.user.areas : [],
							subscribe_date: result.subscribe_date ? result.subscribe_date : '',
							is_present: result.is_present,
							selected: false,
						}
						return user
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		saveUsers() {
			this.$q.loading.show()

			let data = {
				users: this.users_subscribed.map((e) => e.id).filter((user, id) => user.id !== id),
			}

			this.$axios
				.post(
					`/admin_live_classes/live_classes/${this.live_class_id}/guests/`,
					data,
					this.getHeader
				)
				.then(() => {
					this.$q.notify({
						message: this.$t('subscribers_list_save_success'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)

					this.$q.notify({
						message: this.$t('subscribers_list_save_error'),
						type: 'negative',
						icon: 'fas fa-ban',
					})
				})
				.finally(() => {
					this.clearUsersSelection()
					this.$q.loading.hide()
					this.search = ''
				})
		},

		removeUser(props) {
			this.users_subscribed.splice(props.row.__index, 1)
			this.saveUsers()
		},

		removeUsers() {
			this.users_subscribed_selected.map((e) => {
				this.users_subscribed = this.users_subscribed.filter((f) => f.id !== e.id)
			})

			this.saveUsers()
		},

		clearUsersSelection() {
			this.users_subscribed_selected = []
			this.request({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		downloadGuestList() {
			let message = this.$t('generating_guest_list_download_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`/admin_live_classes/live_classes/${
						this.live_class_id
					}/guests/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		getQuantityBranches(branches) {
			return branches.length > 0 ? branches.length : '0'
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		translateProfiles(value) {
			const profile = value.toUpperCase()
			const term = this.profiles.find((e) => e.translations[0].name.toUpperCase() === profile)
			if (term) {
				let translated = term.label.toLowerCase()
				return translated.charAt(0).toUpperCase() + translated.slice(1)
			} else return value
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},
	},

	created() {
		this.live_class_id = this.$route.params.id

		this.request({
			pagination: this.server_pagination,
		})
	},
}
</script>

<style></style>
